import React from "react";
import s from "./colorLegend.module.css";

const ColorLegend = ({ colorscale }) => {
  return (
    <div className={s.chartlegend}>
      {colorscale.domain().map((d) => {
        return (
          <div className={s.pillcontainer} key={d}>
            <div
              className={s.pill}
              style={{ backgroundColor: colorscale(d) }}
            ></div>
            <div className={s.pilllabel}>{d}</div>
          </div>
        );
      })}
    </div>
  );
};

export default ColorLegend;
